import React from 'react'
import useQuotes from '../../hooks/useQuotes'

const Quotes = () => {
    const Quotes = useQuotes
    return (
        <div>
            <blockquote>
                <p>&ldquo;{Quotes.message}.&ldquo;
                    <br></br>  <small>— {Quotes.name}, {Quotes.date}.</small>
                </p>
            </blockquote>
        </div>
    )
}

export default Quotes